export * from './document.service';
import { DocumentService } from './document.service';
export const APIS = [DocumentService];
